<ion-item-group>
  <ion-item-divider>
    <ion-label translate>Mobile.Connectivity</ion-label>
  </ion-item-divider>

  <ion-item (click)="onReload()" lines="none">
    <ion-label translate>SagaMobile.Reload</ion-label>
    <ion-icon slot="end" name="sync-outline" color="primary"></ion-icon>
  </ion-item>
</ion-item-group>
